import { lazy, Suspense } from 'react';

// Lazy load modal components
const AssignmentModal = lazy(() => import('./AssignmentModal'));
const StatusModal = lazy(() => import('./StatusModal'));
const RejectionModal = lazy(() => import('./RejectionModal'));
const DriverTripsModal = lazy(() => import('./DriverTripsModal'));
const ServiceDetailsModal = lazy(() => import('./ServiceDetailsModal'));

// Loading component for modals
const ModalLoader = () => (
  <div className="modal-overlay" style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'rgba(0, 0, 0, 0.7)'
  }}>
    <div style={{
      background: 'var(--panel-bg)',
      borderRadius: '12px',
      padding: '40px',
      textAlign: 'center',
      color: 'var(--text)'
    }}>
      <div style={{
        width: '32px',
        height: '32px',
        border: '3px solid rgba(255,255,255,0.1)',
        borderTop: '3px solid var(--secondary)',
        borderRadius: '50%',
        animation: 'spin 1s linear infinite',
        margin: '0 auto 16px'
      }}></div>
      <p>Cargando modal...</p>
    </div>
  </div>
);

// Wrapper components with Suspense
export const LazyAssignmentModal = (props) => (
  <Suspense fallback={<ModalLoader />}>
    <AssignmentModal {...props} />
  </Suspense>
);

export const LazyStatusModal = (props) => (
  <Suspense fallback={<ModalLoader />}>
    <StatusModal {...props} />
  </Suspense>
);

export const LazyRejectionModal = (props) => (
  <Suspense fallback={<ModalLoader />}>
    <RejectionModal {...props} />
  </Suspense>
);

export const LazyDriverTripsModal = (props) => (
  <Suspense fallback={<ModalLoader />}>
    <DriverTripsModal {...props} />
  </Suspense>
);

export const LazyServiceDetailsModal = (props) => (
  <Suspense fallback={<ModalLoader />}>
    <ServiceDetailsModal {...props} />
  </Suspense>
);
